import * as api from 'common/api'

// 部门类型
export async function types () {
  return [
    {name: '教学', en_name: 'teaching'},
    {name: '管理', en_name: 'admin'},
    {name: '其他', en_name: 'others'},
  ]
}

// 部门列表
export let list = params => api.get('account/school/department/list', params)

// 班级部门：名称、开通功能
export let edit = params => api.post('account/school/department/edit', params)
// 查看部门：名称、开通功能
export let get = params => api.get('account/school/department/edit', params)
// 部门下人员列表
export let teacher_list = params => api.get('account/department/teacher/list', params)
// 配置部门下人员(添加、删除)
export let teacher_edit = params => api.post('account/department/teacher/edit', params)



// WEBPACK FOOTER //
// ./src/api/department.js